export default {
  employeePageLayout: null,
  employeeSummaryLayout: null,
  employeeWidgetLayout: null
};
